import { createElement, memo } from "react";
import { AresModal, AresModalProps } from "../../styled/AresModal";
import { useModal, useModalMessages, WrappedModalProps } from "../ModalContext";


export const ModalContainer = memo(() => {
  const modalPropsList = useModalMessages();

  const { remove } = useModal();

  return (
    <>
      {modalPropsList.map((props: WrappedModalProps, index) => {
        const modalProps: AresModalProps = {
          ...props,
          onRequestClose: () => remove(props.messageKey),
          isOpen: true,
        };

        return createElement(AresModal, { ...modalProps, key: props.messageKey });
      })}
    </>
  );
});